import React, { Component } from "react";
import { deleteSubmissions, getFile } from "../../services/submissionService";
import PaginationSetup from "../common/pagination";
import { paginate } from "../Utils/paginate";
import { DropDown } from "../common/dropDown";
import SearchBox from "../searchBox";
import ProposalTable from "../proposalsTable";
import LinkButton from "../common/linkButton";
import ProposalDetailsModal from "../proposalDetails/proposalDetailsModal";
import ISPDetailsModal from "../ISP/ispDetailsModal";
import "./proposalSubmissions.css";
import { Prompt } from "react-router-dom";
import DropDownAction from "../common/dropDownAction";
import Copy from "../../Images/copy.png";
import Agreement from "../../Images/Agreement-32.png";

export default class ProposalSubmissions extends Component {
  _isMounted = false;

  noFocusStyleBtn = {
    backgroundColor: "transparent",
    color: "black",
    float: "right",
  };

  actionButtonBaseStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    padding: "8px 12px",
    textAlign: "left",
    border: "none",
    borderRadius: "0",
    color: "white",
  };

  getActionButtonStyle = (variant, disabled = false) => {
    const palette = {
      isp: "#FF6A42",
      primary: "#385EA4",
      danger: "#dc3545",
    };

    return {
      ...this.actionButtonBaseStyle,
      backgroundColor: palette[variant],
      opacity: disabled ? 0.65 : 1,
      cursor: disabled ? "not-allowed" : "pointer",
    };
  };

  constructor(props) {
    super(props);
    this.state = {
      proposals: this.props.proposals,
      proposalTypes: [
        { _id: "", name: "All Strategies" },
        ...this.props.proposalTypes,
      ],
      currentPage: 1,
      pageSize: 6,
      searchQuery: "",
      selectedType: 0,
      sortColumn: {
        path: "DateTime",
        order: "asc",
      },
      showDetails: this.props.showDetails,
      shouldBlockNavigation: false,
      selected: {},
      selectAll: 0,
      deleteAllInProgress: false,
      columnsList: [],
      selectedColumn: { label: "Client Name(s)", path: "CLIENT NAMES" },
      dateOutofRange: false,
      showProposalDetailsModal: false,
      showISPDetailsModal: false,
      showDeleteConfirmModal: false,
      modalProposal: null,
      modalISP: null,
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    if (
      this._isMounted &&
      new Date(new Date(this.props.updateTime).toLocaleDateString()).getTime() <
        new Date(new Date().toLocaleDateString()).getTime()
    ) {
      this.setState({ dateOutofRange: true });
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.state.shouldBlockNavigation) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }

    // Sync proposals and proposalTypes from parent when they change
    if (prevProps.proposals !== this.props.proposals) {
      this.setState({ proposals: this.props.proposals });
    }
    // Recalculate stale-data indicator when updateTime changes
    if (prevProps.updateTime !== this.props.updateTime) {
      const lastUpdate = new Date(new Date(this.props.updateTime).toLocaleDateString()).getTime();
      const today = new Date(new Date().toLocaleDateString()).getTime();
      this.setState({ dateOutofRange: lastUpdate < today });
    }
    if (prevProps.proposalTypes !== this.props.proposalTypes) {
      this.setState({
        proposalTypes: [
          { _id: "", name: "All Strategies" },
          ...this.props.proposalTypes,
        ],
      });
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    window.onbeforeunload = null;
  };

  delay = (ms) => new Promise((res) => setTimeout(res, ms));

  processDelete = async (proposals) => {
    let selectedRows = this.state.selected;
    let updatedProposals = this.state.proposals;
    Object.keys(proposals).forEach(async (element) => {
      updatedProposals = this.state.proposals.filter(
        (p) =>
          p.DateTime + p["CLIENT NAMES"] !==
          selectedRows[element].DateTime +
            selectedRows[element]["CLIENT NAMES"],
      );
      const delDate = new Date(selectedRows[element].DateTime);
      await deleteSubmissions(
        delDate.toUTCString(),
        selectedRows[element].UserName,
      ).catch((e) =>
        alert(
          `Error: ${e.message} : Error deleting ${
            selectedRows[element].DateTime +
            selectedRows[element]["CLIENT NAMES"]
          }`,
        ),
      );
      delete selectedRows[element];
    });
    this.setState({ proposals: updatedProposals, selected: selectedRows });
    await this.delay(2000);
    this.props.updateProposalsState();
  };

  handleDelete = (proposals) => {
    this.handleShouldBlockNavigation();
    this.processDelete(proposals);
    this.handleShouldBlockNavigation();
  };

  getSelectedSubmission = () => {
    const selectedKeys = Object.keys(this.state.selected);
    if (selectedKeys.length !== 1) return null;
    return this.state.selected[selectedKeys[0]];
  };

  hasProposalData = (proposal) => {
    if (!proposal) return false;
    return proposal.submissionType !== "ISP";
  };

  hasISPData = (proposal) => {
    return !!proposal?.ispFormData;
  };

  openProposalDetails = () => {
    const selectedSubmission = this.getSelectedSubmission();
    if (!this.hasProposalData(selectedSubmission)) return;

    this.setState({
      showProposalDetailsModal: true,
      modalProposal: selectedSubmission,
    });
  };

  openISPDetails = () => {
    const selectedSubmission = this.getSelectedSubmission();
    if (!this.hasISPData(selectedSubmission)) return;

    this.setState({
      showISPDetailsModal: true,
      modalISP: selectedSubmission,
    });
  };

  openDeleteConfirmModal = () => {
    if (Object.keys(this.state.selected).length === 0) return;
    this.setState({ showDeleteConfirmModal: true });
  };

  closeDeleteConfirmModal = () => {
    this.setState({ showDeleteConfirmModal: false });
  };

  confirmDelete = async () => {
    const selectedRows = this.state.selected;
    this.setState({ showDeleteConfirmModal: false });
    await this.handleDelete(selectedRows);
  };

  download(filename, text, contextType = "text/plain") {
    var element = document.createElement("a");
    element.setAttribute("href", `data:${contextType};base64,` + text);
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  handleDownload = async (proposal, callBackProgress, fileType = '') => {
    try {
      let text = "";
      let promises = [];
      let results = [];
      async function handlePromis(promises) {
        results = await Promise.all(promises);
      }
      // Generate download
      const delDate = new Date(proposal.DateTime);
      let result = await getFile(delDate.toUTCString(), proposal.UserName, 0, fileType);
      let completedPromises = 1;
      const totalPromises = result.chunks;
      callBackProgress(
        Math.round((completedPromises / parseInt(result.chunks)) * 100),
      );
      text = result.data;
      if (parseInt(result.chunks) > 1) {
        for (let index = 1; index < parseInt(result.chunks); index++) {
          const delDate = new Date(proposal.DateTime);
          promises.push(getFile(delDate.toUTCString(), proposal.UserName, index, fileType));
        }
        handlePromis(promises);
      }
      do {
        await this.sleep(500);
        for (let index = 0; index < results.length; index++) {
          if (results[index].requestedSection === String(completedPromises)) {
            text = text + results[index].data;
            completedPromises = completedPromises + 1;
          }
        }
        callBackProgress(
          Math.round((completedPromises / parseInt(result.chunks)) * 100),
        );
      } while (String(completedPromises) !== totalPromises);
      const rawFileName = fileType === 'isp'
        ? (proposal.ispFileName || proposal.FileName)
        : proposal.FileName;
      const baseName = rawFileName.split('/').pop();
      const downloadFileName = baseName.replace(proposal.UserName, proposal["CLIENT NAMES"]);
      this.download(
        downloadFileName,
        text,
        result.contentType,
      );
      text = "";
      promises = [];
      results = [];
    } catch (error) {
      console.error("Download failed:", error);
      this.removeProgress(proposal);
      alert("Download failed. Please try refreshing the page and try again.");
    }
  };

  handleCopy = (proposal) => {
    this.props.copySubmission(proposal);
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
    this.getPagedData();
    return false;
  };

  handleSelectedColumn = (columnLabel) => {
    const columnList = this.state.columnsList;
    let columnElement = {};
    columnList.forEach((element) => {
      if (element.label === columnLabel) columnElement = element;
    });
    this.setState({ selectedColumn: columnElement });
  };

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      selectedType: this.state.selectedColumn,
      currentPage: 1,
    });
    this.handlePageSize(6);
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handlePageSize = (number) => {
    this.setState({ pageSize: number, currentPage: 1 });
  };

  handleShouldBlockNavigation = () => {
    this.setState((prevState) => {
      return { shouldBlockNavigation: !prevState.shouldBlockNavigation };
    });
  };

  handleToggleRow = (proposal, e) => {
    const id = `${proposal["CLIENT NAMES"]}_${proposal["DateTime"]}`;
    const checked = e.target.checked;
    if (checked === false) {
      let selectedRows = this.state.selected;
      delete selectedRows[id];
      this.setState({ selected: selectedRows });
    } else {
      this.setState((previousState) => {
        return {
          selected: {
            ...previousState.selected,
            [id]: proposal,
          },
        };
      });
    }
  };

  handleToggleSelectAll = () => {
    const { data: proposals } = this.getPagedData();
    let newSelected = {};
    if (this.state.selectAll === 0) {
      proposals.forEach((x) => {
        if (x["Download"] === "true") {
          newSelected[`${x["CLIENT NAMES"]}_${x["DateTime"]}`] = x;
        }
      });
    }
    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0,
    });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      selectedType,
      searchQuery,
      proposals: allproposals,
    } = this.state;

    let filtered = allproposals;

    if (searchQuery)
      filtered = allproposals.filter((p) => {
        return String(p[this.state.selectedColumn.path])
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      });
    else if (
      selectedType.name &&
      selectedType !== this.state.proposalTypes[0]
    ) {
      filtered = allproposals.filter(
        (p) =>
          String(p.program).toLowerCase() === selectedType.name.toLowerCase(),
      );
    }

    let sorted = filtered;
    if (searchQuery) {
      sorted = filtered.sort((p1, p2) => {
        const path = this.state.selectedColumn.path;
        if (p1[path] < p2[path]) {
          return -1;
        }
        if (p1[path] > p2[path]) {
          return 1;
        }
        return 0;
      });
    } else {
      if (sortColumn.path !== undefined) {
        const path = sortColumn.path.toString().split("-")[0].trim();
        sorted = filtered.sort((p1, p2) => {
          if (path.toLowerCase() === "datetime") {
            const path = "DateTime";
            if (new Date(p1[path]).getTime() < new Date(p2[path]).getTime()) {
              return sortColumn.order === "asc" ? 1 : -1;
            }
            if (new Date(p1[path]).getTime() > new Date(p2[path]).getTime()) {
              return sortColumn.order === "asc" ? -1 : 1;
            }
            return 0;
          } else if (path.toLowerCase() === "value") {
            const path = "VALUE";
            if (
              Number(p1[path].replace(/[^0-9]+/g, "")) >
              Number(p2[path].replace(/[^0-9]+/g, ""))
            ) {
              return sortColumn.order === "asc" ? 1 : -1;
            }
            if (
              Number(p1[path].replace(/[^0-9]+/g, "")) <
              Number(p2[path].replace(/[^0-9]+/g, ""))
            ) {
              return sortColumn.order === "asc" ? -1 : 1;
            }
            return 0;
          } else {
            if (p1[path] > p2[path]) {
              return sortColumn.order === "asc" ? 1 : -1;
            }
            if (p1[path] < p2[path]) {
              return sortColumn.order === "asc" ? -1 : 1;
            }
            return 0;
          }
        });
      }
    }
    const proposals = paginate(sorted, currentPage, pageSize);
    return { totalCount: sorted.length, data: proposals };
  };

  updateColumnList = (newList) => {
    this.setState({ columnsList: newList });
  };

  render() {
    const { length: count } = this.state.proposals;
    const {
      pageSize,
      currentPage,
      sortColumn,
      searchQuery,
      selected,
      dateOutofRange,
      showDeleteConfirmModal,
    } = this.state;
    const { totalCount, data: proposals } = this.getPagedData();
    const selectedSubmission = this.getSelectedSubmission();
    const selectedCount = Object.keys(selected).length;
    const canCopyProposal =
      selectedCount === 1 && this.hasProposalData(selectedSubmission);
    const canCopyISP =
      selectedCount === 1 && this.hasISPData(selectedSubmission);
    const canViewProposalDetails =
      selectedCount === 1 && this.hasProposalData(selectedSubmission);
    const canViewISPDetails =
      selectedCount === 1 && this.hasISPData(selectedSubmission);
    const canDelete = selectedCount >= 1;
    if (count === 0)
      return (
        <div>
          <div
            style={{
              height: "calc(100vh - 50px)",
              position: "fixed",
              width: "100vw",
              backgroundColor: "#A2AAB6",
            }}
          />
          <p
            style={{
              color: "white",
              fontSize: "2rem",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            There are no proposals right now....
          </p>
        </div>
      );

    proposals.forEach((element) => {
      if (element.DateTime) {
        var myDate = new Date(element.DateTime);
        element.DateTime = myDate.toLocaleString();
      }
    });

    let cardSizeStyle = { top: "35px" };

    if (this.state.showDetails) {
      cardSizeStyle = {
        width: "calc(100% + 20%)",
        left: "-10%",
        top: "35px",
      };
    }

    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 50px)",
            position: "fixed",
            width: "100vw",
            backgroundColor: "#A2AAB6",
            pointerEvents: "none",
          }}
        />
        <Prompt
          when={this.state.shouldBlockNavigation}
          message="If you leave now all unfinished deletes will be discarded! Please wait just another 10-15 seconds."
        />
        <div>
          <div className="container" style={{ minWidth: "1000px" }}>
            <div className="card" style={cardSizeStyle}>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <div style={{ marginBottom: "10px" }}>
                      <LinkButton
                        to="/proposals/step-guide"
                        className="btn btn-success"
                        style={{ marginRight: "5px" }}
                        onClick={() => this.props.newBlankProposal()}
                      >
                        New Proposal
                      </LinkButton>

                      <LinkButton
                        to="/plan/step-guide"
                        className="btn btn-primary"
                        style={{ marginRight: "5px" }}
                        title="Create Investment Strategy Plan and Fee Disclosure (ISP)"
                        onClick={() =>
                          this.props.clearProposalState &&
                          this.props.clearProposalState()
                        }
                      >
                        New ISP
                      </LinkButton>

                      <button
                        style={{
                          float: "right",
                          backgroundColor: "#385EA4",
                          color: "white",
                        }}
                        className="btn"
                        onClick={() => {
                          this.props.updateProposalsState();
                          this.setState({
                            proposals: this.props.proposals,
                            dateOutofRange: false,
                          });
                        }}
                      >
                        {this.props.submissionsRequestSent ||
                        this.props.submissionsLoading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : null}{" "}
                        Refresh
                      </button>
                    </div>

                    <div>
                      <label>
                        Showing {totalCount}{" "}
                        {totalCount === 1 ? "proposal" : "proposals"} in the
                        database.
                      </label>
                      {dateOutofRange && (
                        <div
                          class="spinner-grow text-secondary"
                          role="status"
                          style={{ float: "right" }}
                        ></div>
                      )}
                      <label style={{ float: "right" }}>
                        Last Updated: {this.props.updateTime}
                      </label>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          display: "inline-block",
                          margin: "auto 5px auto auto",
                        }}
                      >
                        <DropDown
                          title={"Search By"}
                          items={this.state.columnsList.map(
                            (c) => (c = c.label),
                          )}
                          textProperty={"name"}
                          valueProperty={""}
                          selectedItem={0}
                          onItemSelect={this.handleSelectedColumn}
                        />
                      </div>
                      <div style={{ display: "inline-flex", width: "100%" }}>
                        <SearchBox
                          value={searchQuery}
                          onChange={this.handleSearch}
                          placeholder={`Search by ${this.state.selectedColumn.label}...`}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        height: "35px",
                      }}
                    >
                      <DropDownAction
                        customStyle={{
                          backgroundColor:
                            Object.keys(selected).length > 0
                              ? "#5cb85c"
                              : "#385EA4",
                          color: "white",
                          outline: "none",
                          border: "none",
                          height: "38px",
                        }}
                        style={{
                          outline: "none",
                          border: "none",
                          margin: "none",
                          display: "inline-flex",
                          marginRight: "5px",
                        }}
                        ulStyle={{
                          padding: "0",
                        }}
                        title={
                          <div style={{ paddingBottom: "2px" }}>
                            {this.state.shouldBlockNavigation === true ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : null}
                            Actions{" "}
                            <span style={{ margin: "auto", fontSize: "10px" }}>
                              &#9660;
                            </span>
                          </div>
                        }
                        drop="dropdown"
                        items={[
                          <LinkButton
                            to="/proposals/step-guide"
                            type="button"
                            title="Copy Proposal"
                            disabled={!canCopyProposal}
                            onClick={() => this.handleCopy(selectedSubmission)}
                            className="btn btn-sm submissions-action-btn submissions-action-btn-primary"
                            style={this.getActionButtonStyle(
                              "primary",
                              !canCopyProposal,
                            )}
                          >
                            <span className="submissions-action-icon">
                              <img
                                src={Copy}
                                alt="Copy Proposal"
                                style={{ height: "20px" }}
                              />
                            </span>
                            <span>Copy Proposal</span>
                          </LinkButton>,
                          <LinkButton
                            to="/plan/step-guide"
                            type="button"
                            title="Copy ISP"
                            disabled={!canCopyISP}
                            onClick={() => {
                              if (selectedSubmission?.ispFormData) {
                                sessionStorage.setItem(
                                  "editISPData",
                                  selectedSubmission.ispFormData,
                                );
                              }
                            }}
                            className="btn btn-sm submissions-action-btn submissions-action-btn-isp"
                            style={this.getActionButtonStyle(
                              "isp",
                              !canCopyISP,
                            )}
                          >
                            <span className="submissions-action-icon">
                              <img
                                src={Copy}
                                alt="Copy ISP"
                                style={{ height: "20px" }}
                              />
                            </span>
                            <span>Copy ISP</span>
                          </LinkButton>,
                          <button
                            type="button"
                            title="Delete"
                            disabled={!canDelete}
                            onClick={this.openDeleteConfirmModal}
                            className="btn btn-sm submissions-action-btn submissions-action-btn-danger"
                            style={this.getActionButtonStyle(
                              "danger",
                              !canDelete,
                            )}
                          >
                            <span className="submissions-action-icon submissions-action-icon-text">
                              X
                            </span>
                            <span>Delete</span>
                          </button>,
                          <button
                            type="button"
                            title="Full Details Proposal"
                            disabled={!canViewProposalDetails}
                            onClick={this.openProposalDetails}
                            className="btn btn-sm submissions-action-btn submissions-action-btn-primary"
                            style={this.getActionButtonStyle(
                              "primary",
                              !canViewProposalDetails,
                            )}
                          >
                            <span className="submissions-action-icon">
                              <img
                                src={Agreement}
                                alt="Full Details Proposal"
                                style={{ height: "20px" }}
                              />
                            </span>
                            <span>Full Details Proposal</span>
                          </button>,
                          <button
                            type="button"
                            title="Full Details ISP"
                            disabled={!canViewISPDetails}
                            onClick={this.openISPDetails}
                            className="btn btn-sm submissions-action-btn submissions-action-btn-isp"
                            style={this.getActionButtonStyle(
                              "isp",
                              !canViewISPDetails,
                            )}
                          >
                            <span className="submissions-action-icon">
                              <img
                                src={Agreement}
                                alt="Full Details ISP"
                                style={{ height: "20px" }}
                              />
                            </span>
                            <span>Full Details ISP</span>
                          </button>,
                        ]}
                      ></DropDownAction>
                      <div
                        style={{ marginRight: "8px", display: "inline-block" }}
                      >
                        <DropDown
                          title={"Proposals Per Page"}
                          items={[6, 10, 20, 50, 100, 1000]}
                          textProperty={""}
                          valueProperty={""}
                          selectedItem={this.state.pageSize}
                          onItemSelect={this.handlePageSize}
                        />
                      </div>
                      <label
                        className="btn"
                        style={{
                          backgroundColor: "transparent",
                          color: "black",
                          float: "right",
                          marginLeft: "auto",
                        }}
                        onClick={() => {
                          this.props.updateDetails();
                          this.setState((prevState) => {
                            return {
                              ...prevState,
                              showDetails: !prevState.showDetails,
                            };
                          });
                        }}
                        onBlur={(e) => e.preventDefault()}
                      >
                        {this.state.showDetails
                          ? "Show Fewer Details..."
                          : "Show Details..."}
                      </label>
                    </div>

                    <ProposalTable
                      updateColumnList={this.updateColumnList}
                      showDetails={this.state.showDetails}
                      proposals={proposals}
                      sortColumn={sortColumn}
                      onDownload={this.handleDownload}
                      onSort={this.handleSort}
                      updateProposalsState={this.props.updateProposalsState}
                      deleteAllInProgress={this.state.deleteAllInProgress}
                      selected={this.state.selected}
                      selectAll={this.state.selectAll}
                      handleToggleRow={this.handleToggleRow}
                      handleToggleSelectAll={this.handleToggleSelectAll}
                      onCreateProposalFromISP={this.props.onCreateProposalFromISP}
                      onCreateISPFromProposal={this.props.onCreateISPFromProposal}
                      onEditISP={this.props.onEditISP}
                      proposalTypes={this.props.proposalTypes}
                    />
                    <PaginationSetup
                      itemsCount={totalCount}
                      pageSize={pageSize}
                      currentPage={currentPage}
                      onPageChange={this.handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProposalDetailsModal
          show={this.state.showProposalDetailsModal}
          onHide={() =>
            this.setState({
              showProposalDetailsModal: false,
              modalProposal: null,
            })
          }
          proposal={this.state.modalProposal}
          lists={this.props.lists}
        />
        <ISPDetailsModal
          show={this.state.showISPDetailsModal}
          onHide={() =>
            this.setState({ showISPDetailsModal: false, modalISP: null })
          }
          proposal={this.state.modalISP}
          lists={this.props.lists}
        />
        {showDeleteConfirmModal && (
          <div>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 1060 }}
              tabIndex="-1"
              role="dialog"
              aria-modal="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" style={{ color: "#dc3545" }}>
                      Delete Submission{selectedCount === 1 ? "" : "s"}
                    </h5>
                  </div>
                  <div className="modal-body">
                    <p className="submissions-confirm-message">
                      Are you sure you want to delete{" "}
                      {selectedCount === 1 ? "this submission" : "these submissions"}?
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={this.closeDeleteConfirmModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={this.confirmDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
